export class RequestCanceller {
    promise: Promise<any>;
    resolver: any;

    constructor() {
        this.promise = null;
        this.resolver = null;
    }

    /**
     * @return {Promise}
     */
    start() {
        this.promise = new Promise(resolver => {
            this.resolver = resolver;
        });

        return this.promise;
    }

    cancel() {
        if (this.resolver) {
            this.resolver();
            this.resolver = null;
            this.promise = null;
        }
    }
}
